module.exports = __webpack_public_path__ + "img/arrow-up-long.51872847.svg";